<template>
    <Frame>
        <PageHeader :title="title" :hasBack="true" detailType="BulletinCenterDetail" ref="pageheader"/>
        <div class="body-container">
            <div class="timeinfo">
                <span>{{ timeinfo }}</span>
                <div class="fun-buttons">
                    <div  class="button option-icon" id="downloadBillAccess" @click="download('All',true)">
                        <svg-icon  icon-class="downloadBillAccess" />{{ $t('BulletinCenter.downloadAccess') }}
                    </div>
                </div>
            </div>
            <div class="helpinfo" ref="innerhtml" :style="height" id="info"></div>
        </div>
        <BillAccDialog ref="BillAccDialog"></BillAccDialog>
    </Frame>
</template>

<script>
import BillAccDialog from '@/components/BillAccDialog.vue';
export default {
    components:{
        BillAccDialog
    },
    data() {
        return {
            title: "",
            html: "",
            BillNo: "",
            SendTime: "",
            username: "",
            timeinfo: "",
            height: "height:" + window.innerHeight - 237 + "px;",
            ProgId:'capPersonalBulletin',
            InternalId:'',
        }
    },
    methods: {
        download(action,isBillAccess){
            var dialogtitle = this.$t('button.downloadAccess') + "(" + this.BillNo + ")";
            this.$refs.BillAccDialog.GetAccList(this.BillNo,this.ProgId,this.InternalId,action,isBillAccess,dialogtitle);
        },
    },
    created() {
        this.title = this.$route.query.Title;
        this.BillNo = this.$route.query.BillNo;
    },
    mounted() {
        let that = this
        //vue里不建议用document.getelementbyid,这里暂时先处理，后续有好方法再改动
        var info = document.getElementById("info");
        info.style.height = window.innerHeight - 187 - this.$refs.pageheader.$el.clientHeight + "px";
        window.onresize = () => {
            if (that.resizeFlag) {
                clearTimeout(that.resizeFlag);
            }
            that.resizeFlag = setTimeout(() => {
                info.style.height = window.innerHeight - 187 - this.$refs.pageheader.$el.clientHeight + "px";
                that.resizeFlag = null;
            }, 100);
        }
        debugger
        this.axiosInvoke(this.sysHandlerUrl,
            {
                action: "getbulletindetail",
                BillNo: this.BillNo
            },
            (res) => {
                var data = eval(res.data);
                console.log(data);
                this.SendTime = data[0].SendTime;
                this.username = data[0].username;
                this.timeinfo = '【  ' + this.$t('BulletinCenter.publisher') + ':  ' + this.username + " " + this.$t('HelpCenter.publishtime') + ': ' + this.SendTime + '  】';
                var html = data[0].html;
                this.$refs.innerhtml.innerHTML = html;
                this.InternalId = data[0].InternalId;
            })
    }


}
</script>

<style scoped>
.body-container {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center
}

.timeinfo {
    width: 100%;
    padding: 20px 0;
    display: flex;
}

.helpinfo {
    overflow: auto;
    width: 100%;
    word-break: break-all;
}
.fun-buttons{
    padding-right: 10%;
}
.button {
  color: #5d5d5d;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
}
.button:hover {
  cursor: pointer;
  color: #0177d5;
}
.option-icon{
  filter: grayscale(100%);
  margin:0 2.5%;
}
.option-icon:hover{
  filter: grayscale(0%);
}
</style>